import {
  IndexTable,
  LegacyCard,
  IndexFilters,
  useSetIndexFiltersMode,
  useIndexResourceState,
  Text,
  Badge,
  Checkbox,
  IndexFiltersMode,
  useBreakpoints,
  Select,
  Icon,
  TextField,
  Button,
  InlineStack,
} from "@shopify/polaris";
import { useState, useCallback, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { DeleteIcon } from "@shopify/polaris-icons";
import { useMemo } from "react";

export default function OrderList() {
  const location = useLocation();
  const queryParamsget = new URLSearchParams(location.search);
  const statusoptions = queryParamsget.get("status");
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const [orders, setOrders] = useState([]);
  const [itemStrings, setItemStrings] = useState([]);
  const [sortSelected, setSortSelected] = useState(["Customer"]);
  const { mode, setMode } = useSetIndexFiltersMode(IndexFiltersMode.Filtering);
  const [queryValue, setQueryValue] = useState(statusoptions || "");
  const [isLoading, setIsLoading] = useState(false);
  const [deleteorder, setDeleteOrder] = useState("");
  const [checkedOrders, setCheckedOrders] = useState({});
  const [updateOrder, setupdateOrder] = useState("");
  const [updateOrdercheckox, setupdateOrdercheckox] = useState("");
  const [adminCheck, setadminCheck] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [orderDeleteId, setOrderDeleteId] = useState(0);

  //Pagination state
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const onCreateNewView = async (value) => {
    await sleep(500);
    setItemStrings([...itemStrings, value]);
    return true;
  };

  const onHandleCancel = () => { };

  const tabs = itemStrings.map((item, index) => ({
    content: item,
    index,
    onAction: () => { },
    id: `${item}-${index}`,
    isLocked: index === 0,
    actions: index === 0 ? [] : [],
  }));

  const sortOptions = [];

  const handleQueryValueChange = useCallback((value) => {
    setQueryValue(value);
  }, []);

  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);

  const handleFiltersClearAll = useCallback(() => {
    handleQueryValueRemove();
  }, [handleQueryValueRemove]);

  const filters = [];
  const appliedFilters = [];

  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const fetchCustomers = useCallback(async () => {
    const baseUrl = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("token");
    if (!token) return;
    const decoded = jwtDecode(token);
    const RepsId = decoded.ids;
    const checkRole = decoded.role;
    const queryParam = checkRole === "sales" ? `repsid=${RepsId}` : "";
    setadminCheck(checkRole);
    setIsLoading(true);

    try {
      let url = "";
      if (deleteorder) {
        url = `${baseUrl}/api/orders/${deleteorder}`;
      } else if (updateOrder) {
        url = `${baseUrl}/api/orders/${updateOrder}`;
      } else {
        url = queryValue
          ? `${baseUrl}/api/orders?search=${encodeURIComponent(
            queryValue
          )}&page=${page}&limit=50&${queryParam}`
          : `${baseUrl}/api/orders?page=${page}&limit=50&${queryParam}`;
      }
      const method = deleteorder ? "DELETE" : updateOrder ? "PUT" : "GET";
      const requestBody = updateOrder
        ? JSON.stringify({
          Complete: updateOrdercheckox,
          outside: true,
        })
        : null;
      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: requestBody,
      });
      const data = await response.json();
      if (deleteorder) {
        setDeleteOrder("");
      }
      if (updateOrder) {
        setupdateOrder("");
      }
      if (data.Orders && Array.isArray(data.Orders)) {
        setOrders(data.Orders);
        setTotalPages(data.totalPages);
        const initialCheckedState = {};
        data.Orders.forEach((order) => {
          initialCheckedState[order._id] = order.Complete === "true";
        });
        setCheckedOrders(initialCheckedState);
      } else {
        setOrders([]);
      }
    } catch (error) {
      console.error("Error fetching Orders:", error.message);
    } finally {
      setIsLoading(false);
    }
  }, [queryValue, page, deleteorder, updateOrder, updateOrdercheckox]);

  const debouncedFetch = useMemo(() => debounce(fetchCustomers, 400), [fetchCustomers]);


  useEffect(() => {
    debouncedFetch();
  }, [debouncedFetch]);

  const resourceName = {
    singular: "order",
    plural: "orders",
  };

  const orderDelete = (id) => {
    setShowPopup(true);
    setOrderDeleteId(id);
    //setDeleteOrder(id);
  };

  const orderOption = () => {
    setDeleteOrder(orderDeleteId);
    setShowPopup(false);
  };

  const handleCheckboxChange = async (orderId, newCheckedState) => {
    setCheckedOrders((prevState) => ({
      ...prevState,
      [orderId]: newCheckedState,
    }));
    setupdateOrdercheckox(newCheckedState);
    setupdateOrder(orderId);
  };

  const toneMap = {
    Draft: "",
    Submitted: "info",
    Production: "warning",
    Shipping: "attention",
    Delivered: "success",
  };

  const orderStatusChange = async (selectedOption, id) => {
    const token = localStorage.getItem("token");
    const baseUrl = process.env.REACT_APP_API_URL;
    const updatedOrders = orders.map((order) =>
      order._id === id ? { ...order, orderStatus: selectedOption } : order
    );

    setOrders(updatedOrders);
    const payload = {
      orderStatus: selectedOption,
      outside: true,
    };

    try {
      const response = await fetch(`${baseUrl}/api/orders/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        return;
      }

      const data = await response.json();

    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const handleChangeQty = async (index, id, value) => {
    const token = localStorage.getItem("token");
    const baseUrl = process.env.REACT_APP_API_URL;
    const updatedOrders = [...orders];
    updatedOrders[index] = {
      ...updatedOrders[index],
      json: {
        ...updatedOrders[index].json,
        Qty: value,
      },
    };
    setOrders(updatedOrders);

    setTimeout(async () => {
      try {
        const response = await fetch(`${baseUrl}/api/orders/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            Qty: value,
            outside: true,
          }),
        });

        if (!response.ok) {
          return;
        }
      } catch (error) {
        console.error("Fetch Error:", error);
      }
    }, 1000);
  };

  const handleChangeTag = async (index, id, value, typeName) => {
    const token = localStorage.getItem("token");
    const baseUrl = process.env.REACT_APP_API_URL;
    const updatedOrders = [...orders];
    updatedOrders[index] = {
      ...updatedOrders[index],
      [typeName]: value
    };
    setOrders(updatedOrders);

    setTimeout(async () => {
      const payloadTag = {
        [typeName]: value,
        outside: true,
      };

      try {
        const response = await fetch(`${baseUrl}/api/orders/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payloadTag),
        });

        if (!response.ok) {
          return;
        }

      } catch (error) {
        console.error("Fetch Error:", error);
      }
    }, 1000);
  };

  const { selectedResources } = useIndexResourceState(orders);

  const formatDate = (isoDate) => {
    const dateObj = new Date(isoDate);
    return dateObj.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  const optionsStatus = [
    { label: 'Draft', value: 'Draft' },
    { label: 'Submitted', value: 'Submitted' },
    { label: 'Production', value: 'Production' },
    { label: 'Shipping', value: 'Shipping' },
    { label: 'Delivered', value: 'Delivered' },
  ];

  const rowMarkup =
    orders && orders.length > 0 ? (
      orders.map(
        (
          { orderId, createdAt, orderStatus, _id, tags, tagNote, json },
          index
        ) => (
          <IndexTable.Row
            id={orderId}
            key={orderId}
            selected={selectedResources.includes(orderId)}
            position={index}
          >
            <IndexTable.Cell>
              <NavLink
                to={`view/${_id}`}
                state={{ orderData: orders[index] }}
              >
                <Text variant="bodyMd" fontWeight="bold" as="span">
                  {orderId}
                </Text>
              </NavLink>
            </IndexTable.Cell>
            <IndexTable.Cell>{json?.customerName}</IndexTable.Cell>
            <IndexTable.Cell>{json?.repName}</IndexTable.Cell>
            <IndexTable.Cell>{json?.Itemtype}</IndexTable.Cell>
            <IndexTable.Cell>{json?.FabricNumber}</IndexTable.Cell>
            <IndexTable.Cell>
              {adminCheck === "admin" ? (
                <div className={`status_select_box status_${(orderStatus || "").toLowerCase()}`}>
                  <Select
                    options={optionsStatus}
                    value={orderStatus}
                    onChange={(selectedOption) => orderStatusChange(selectedOption, _id)} />
                </div>
              ) : (
                <Badge tone={toneMap[orderStatus] || 'default'}>
                  {orderStatus}
                </Badge>
              )}
            </IndexTable.Cell>

            {adminCheck === "admin" ? (
              <IndexTable.Cell>
                <div className="text_input_box">
                  <TextField
                    label=""
                    value={tags}
                    onChange={(value) => handleChangeTag(index, _id, value, 'tags')}
                    autoComplete="off"
                  />
                </div>
              </IndexTable.Cell>
            ) : null}

            <IndexTable.Cell>
              <div className="text_input_box">
                <TextField
                  label=""
                  value={tagNote}
                  onChange={(value) => handleChangeTag(index, _id, value, 'tagNote')}
                  autoComplete="off"
                />
              </div>
            </IndexTable.Cell>
            <IndexTable.Cell>
              <div className="text_input_box qty_input_box">
                <TextField
                  label=""
                  type="number"
                  min="1"
                  value={String(json?.Qty ?? "1")}
                  onChange={(value) => handleChangeQty(index, _id, value)}
                  autoComplete="off"
                />
              </div>
            </IndexTable.Cell>
            <IndexTable.Cell>
              <>
                <div className="cutomer_update_btn">
                  {(orderStatus === "Submitted" || orderStatus === "Draft") && (
                    <NavLink to={_id} state={{ orderData: orders[index] }}>
                      Edit Order
                    </NavLink>
                  )}
                  <NavLink
                    to={`reorder/${_id}`}
                    state={{ orderData: orders[index] }}
                  >
                    Re-Order
                  </NavLink>
                  {(orderStatus === "Submitted" || orderStatus === "Draft") && (
                    <span
                      onClick={() => orderDelete(_id)}
                      style={{ cursor: "pointer" }}
                    >
                      <Icon source={DeleteIcon} tone="base" />
                    </span>
                  )}
                </div>
              </>
            </IndexTable.Cell>
            <IndexTable.Cell>
              {adminCheck === "sales" ? (
                <Checkbox
                  label=""
                  checked={checkedOrders[_id]}
                  onChange={(newCheckedState) =>
                    handleCheckboxChange(_id, newCheckedState)
                  }
                />
              ) : checkedOrders[_id] ? (
                <span>True</span>
              ) : <span>False</span>}
            </IndexTable.Cell>
            <IndexTable.Cell>{formatDate(createdAt)}</IndexTable.Cell>
          </IndexTable.Row>
        )
      )
    ) : (
      <IndexTable.Row>
        <IndexTable.Cell colSpan={7}>No Orders found</IndexTable.Cell>
      </IndexTable.Row>
    );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  return (
    <>
      <div className="button_option">
        <h2>All Orders</h2>
      </div>
      <LegacyCard>
        <IndexFilters
          loading={isLoading}
          sortOptions={sortOptions}
          sortSelected={sortSelected}
          queryValue={queryValue}
          queryPlaceholder="Search by Order ID, Customer, Status, Tag"
          onQueryChange={handleQueryValueChange}
          onQueryClear={handleQueryValueRemove}
          onSort={setSortSelected}
          cancelAction={{
            onAction: onHandleCancel,
            disabled: false,
            loading: false,
          }}
          tabs={tabs}
          canCreateNewView
          onCreateNewView={onCreateNewView}
          filters={filters}
          appliedFilters={appliedFilters}
          onClearAll={handleFiltersClearAll}
          mode={mode}
          setMode={setMode}
        />

        <IndexTable
          condensed={useBreakpoints().smDown}
          resourceName={resourceName}
          itemCount={orders.length}
          headings={[
            { title: "Order ID" },
            { title: "Customer" },
            { title: "Sales Rep" },
            { title: "Item" },
            { title: "Fabric Number" },
            { title: "Status" },
            ...(adminCheck === "admin" ? [{ title: "Tags" }] : []),
            { title: "Note" },
            { title: "Qty" },
            { title: "Action" },
            { title: "Complete" },
            { title: "Created Date" },
          ]}
          selectable={false}
          pagination={{
            hasNext: page < totalPages,
            onNext: () => handlePageChange(page + 1),
            hasPrevious: page > 1,
            onPrevious: () => handlePageChange(page - 1),
            currentPage: page,
            totalPages,
          }}
        >
          {rowMarkup}
        </IndexTable>
      </LegacyCard>
      {showPopup && (
        <div className="popup_delete">
          <div className="popup_delete_box">
            <h3>Are you sure?</h3>
            <InlineStack gap="300">
              <Button variant="primary" onClick={orderOption}>Yes</Button>
              <Button variant="primary" onClick={() => setShowPopup(false)}>No</Button>
            </InlineStack>
          </div>
        </div>
      )}
    </>
  );
}
